import {CalRepeat} from "./utils/model/CalEvent";
import * as moment_ from "moment";

const moment = moment_;
moment.locale('vi');

export class CalendarUtils {
  static repeatTypes = [
    {label: 'Hàng ngày', value: 'DAILY'},
    {label: 'Hàng tuần', value: 'WEEKLY'},
    {label: 'Hàng tháng', value: 'MONTHLY'}
  ];

  static weekDays = [
    {label: 'T2', title: 'Thứ hai', value: 'MO'},
    {label: 'T3', title: 'Thứ ba', value: 'TU'},
    {label: 'T4', title: 'Thứ tư', value: 'WE'},
    {label: 'T5', title: 'Thứ năm', value: 'TH'},
    {label: 'T6', title: 'Thứ sáu', value: 'FR'},
    {label: 'T7', title: 'Thứ bảy', value: 'SA'},
    {label: 'CN', title: 'Chủ nhật', value: 'SU'}
  ];

  static getRepeatText(data: CalRepeat): string {
    let display = '';
    for (let i = 0; i < CalendarUtils.repeatTypes.length; i++) {
      if (CalendarUtils.repeatTypes[i].value === data.rrmode) {
        display = CalendarUtils.repeatTypes[i].label;
      }
    }
    if (data.rrmode === 'WEEKLY' && data.wkdays) {
      display += ' - ' + CalendarUtils._getTextRepeatWeek(data.wkdays);
    }
    return display;
  }

  static _getTextRepeatWeek(wkdays: string[]): string {
    if (wkdays) {
      return CalendarUtils.weekDays.filter(day => {
        return wkdays.indexOf(day.value) > -1;
      }).map(day => {
        return day.title;
      }).join(', ');
    }
    return '';
  }

  static displayDay(date: Date) {
    let str = moment(date).format('dddd, d MMMM');
    if (new Date().getFullYear() !== date.getFullYear()) {
      str += ' năm ' + date.getFullYear();
    }
    return str.slice(0, 1).toUpperCase() + str.slice(1);
  }

  static displayDate(date: Date) {
    return moment(date).format('[Ngày] LL');
  }

  static displayWeek(date: Date) {
    return moment(date).format('[Tuần] w [năm] Y');
  }

  static displayMonth(date: Date) {
    return moment(date).format('[Tháng] MM [năm] Y');
  }

  static displayTime(date: Date) {
    return moment(date).format('HH:mm');
  }

  static computePosByPoint(element: HTMLElement, e: MouseEvent, padding?: number) {
    let bounds = element.getBoundingClientRect();
    let halfHeight = bounds.height / 2;
    let halfWidth = bounds.width / 2;
    let direction;
    let pos: any = {
      left: e.x - halfWidth,
      top: e.y - halfHeight
    };

    padding = padding || 5;

    // Position out of width
    if (innerWidth < pos.left + bounds.width + padding) {
      pos.left = innerWidth - padding - bounds.width;
    } else if (pos.left < padding) {
      pos.left = padding;
    }

    // Position out of height
    if (innerHeight < pos.top + bounds.height + padding) {
      pos.top = innerHeight - padding - bounds.height;
    } else if (pos.top < padding) {
      pos.top = padding;
    }

    // Detect best position
    let deltaTop = e.pageY;
    let deltaBottom = innerHeight - e.pageX;
    let deltaLeft = e.pageX;
    let deltaRight = innerWidth - e.pageY;

    let deltaMax = Math.max(deltaTop, deltaRight, deltaBottom, deltaLeft);

    switch (deltaMax) {
      case deltaTop:
        direction = 'top';
        pos.top -= halfHeight + padding;
        break;
      case deltaBottom:
        direction = 'bottom';
        pos.top += halfHeight + padding;
        break;
      case deltaLeft:
        direction = 'left';
        pos.left -= halfWidth + padding;
        break;
      case deltaRight:
        direction = 'right';
        pos.left += halfWidth + padding;
        break;
    }

    return {
      direction: direction,
      position: pos,
      elementBounds: bounds
    };
  }

  static computePosByTargetEl(element: HTMLElement, target: HTMLElement, jsEvent: MouseEvent, padding?: number) {
    let elementBounds = element.getBoundingClientRect();
    let targetBounds = target.getBoundingClientRect();
    let pos: any = {};
    let direction: any = {};
    padding = padding || 10;

    let deltaRect = {
      top: targetBounds.top,
      right: innerWidth - targetBounds.right,
      bottom: innerHeight - targetBounds.bottom,
      left: targetBounds.left
    };
    let maxX = Math.max(deltaRect.left, deltaRect.right);
    let maxY = Math.max(deltaRect.top, deltaRect.bottom);

    // Get click point when left and right not enough modal
    if (elementBounds.width > maxX) {
      deltaRect.left = jsEvent.pageX;
      deltaRect.right = innerWidth - jsEvent.pageX;
    }

    // Get click point when top and bottom not enough modal
    if (elementBounds.height > maxY) {
      deltaRect.top = jsEvent.pageY;
      deltaRect.bottom = innerHeight - jsEvent.pageY;
    }

    // X direction
    if (deltaRect.left > deltaRect.right) {
      direction.left = true;
      pos.left = deltaRect.left - elementBounds.width;
    } else {
      direction.right = true;
      pos.left = innerWidth - deltaRect.right;
    }

    // Y direction
    if (deltaRect.top > deltaRect.bottom) {
      direction.top = true;
      pos.top = deltaRect.top - elementBounds.height;
    } else {
      direction.bottom = true;
      pos.top = innerHeight - deltaRect.bottom;
    }

    // Best dimension to display
    if (maxX * elementBounds.width > maxY * elementBounds.height) {
      // By x
      let targetHeight = innerHeight - deltaRect.bottom - deltaRect.top;
      if (direction.top) {
        pos.top += targetHeight;
      } else {
        pos.top -= targetHeight;
      }
    } else {
      // By y
      let targetWidth = innerWidth - deltaRect.left - deltaRect.right;
      if (direction.left) {
        pos.left += targetWidth;
      } else {
        pos.left -= targetWidth;
      }
    }

    // Out of width
    if (pos.left < padding) {
      pos.left = padding;
    } else if (pos.left + elementBounds.width > innerWidth) {
      pos.left = innerWidth - elementBounds.width - padding;
    }

    // Out of height
    if (pos.top < padding) {
      pos.top = padding;
    } else if (pos.top + elementBounds.height > innerHeight) {
      pos.top = innerHeight - elementBounds.height - padding;
    }

    // compute with document scroll
    if(document.scrollingElement) {
      pos.top += document.scrollingElement.scrollTop;
      pos.left += document.scrollingElement.scrollLeft;
    }

    return pos;
  }
}
